import '../../../utils/extensions.js';
import ViewBase from '../../view-base.view';
import CVTrainingRequestsListView from './cvtrains/custom-vision.training-requests-list.view';

export default function CustomVisionTrainingView() {
    ViewBase.call(this);

    return {
        view: (vnode) => {
            return [
                m(CVTrainingRequestsListView),
                this.getBaseViews()
            ];
        }
    }
}
